// extracted by mini-css-extract-plugin
export default {"page":"t0-z","cartModal":"u0-z","checkout":"v0-z","placeholder":"w0-z","account":"x0-z"};